<template>
  <div
    class="button-container"
    :class="stylePadding">
    <div
      class="button-ok"
      :class="styleDisabled"
      @click="click">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    action: {
      type: Function
    },

    padding: {
      type: String
    },

    disabled: {}
  },

  computed: {
    stylePadding: function () {
      if (this.padding === 's') {
        return { 'button-padding_s': true }
      }
      return {}
    },

    styleDisabled: function () {
      if (this.disabled) {
        return { 'button-disabled': true }
      }
      return {}
    }
  },

  methods: {
    click: function () {
      if (this.disabled) {
        return
      }
      this.action()
    }
  }
}
</script>

<style lang="scss" scoped>
.button-container {
  padding: 30px;
  display: flex;
  justify-content: center;
}

.button-padding {
  &_s {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.button-ok {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  background: #3498db;
  color: white;
  border-radius: 4px;
  font-size: 1.1em;

  &:hover {
    cursor: pointer;
  }
}

.button-disabled {
  background: rgba(0, 0, 0, 0.2);
  &:hover {
    cursor: default;
  }
}
</style>
